"use client"

import { useRegion } from "hooks"
import { redeemReferralCode } from "lib/api"
import { duplicateRafRedemptionModalVar } from "lib/apollo/variables/uxVars"
import { useSearchParams } from "next/navigation"
import { useEffect } from "react"

export const useRedeemReferralPage = (isRedeeemReferralPage: boolean): void => {
  const params = useSearchParams()
  const referralCode = params?.get("referralCode")

  const region = useRegion()

  useEffect(() => {
    if (
      !referralCode ||
      typeof referralCode !== "string" ||
      !isRedeeemReferralPage
    ) {
      return
    }
    redeemReferralCode(referralCode)
      .then(({ redeemReferralCode: res }) => {
        if (
          res.rejectedDiscounts.some(
            (item) => item.state === "ReferralCustomerAlreadyReferred"
          )
        ) {
          duplicateRafRedemptionModalVar(true)
        }
      })
      .catch(() => {
        console.error(`Could not redeem referral`)
      })
  }, [region, referralCode, isRedeeemReferralPage])
}
